module.exports = __webpack_public_path__ + "media/images/people/2-9d1938bb7142cedc8426cd58aa96ca40.jpg";